import React, { forwardRef, HTMLAttributes, ReactNode } from 'react';
import cn from 'classnames';

export interface BadgeProps extends HTMLAttributes<HTMLDivElement> {
    label?: ReactNode;
    /**
     * Type of badge (neutral, warning, error), default is 'neutral'
     */
    type?: 'neutral' | 'warning' | 'error';
}

/**
 * Representation of badges
 */
export const Badge = forwardRef<HTMLDivElement, BadgeProps>((props, ref) => {
    const { label, type = 'neutral', className, ...rest } = props;
    const classes = cn('a-badge', { [`-${type}`]: type }, className);

    return (
        <div ref={ref} className={classes} {...rest}>
            {label}
        </div>
    );
});
Badge.displayName = 'Badge';
